enum ActionType {
    REQUEST_CONFIG = '[CORE/CONFIG] GET CONFIG',
    RECEIVE_CONFIG = '[CORE/CONFIG] SET CONFIG',
    CONFIG_ERROR = '[CORE/CONFIG] CONFIG ERROR',
}

export default ActionType
